/**
 * This component is the list page view on search results page
 */

import vxProductTileVertical from '../../../b2c/search-browse/vx-product-tile-vertical/vx-product-tile-vertical.vue';
import mobileMixin from '../../../common/mixins/mobile-mixin';

export default {
  name: 'vx-list-page',
  data() {
    return {
      compareProduct: [],
      disableButtonFalse: false,
      totalCheckedCount: 0,
      uncheckProduct: false,
      receivedCount: 0,
      assetLevel: '',
      showCompareCheckbox: true,
      viewportCount: 4,
      viewportSize: 0,
    };
  },
  props: {
    /**
     * product catalog for respective categories
     */
    products: {
      type: Object,
    },
    /**
     * indicates whether the site is configured for favorites
     */
    isFavorites: {
      type: Boolean,
      default: false,
    },
    /**
     * indicates whether the site is configured for Bazaar Voice
     */
    isBazaarVoice: {
      type: String,
      default: '',
    },
    /**
     * Copy text coming from properties files for search browse components
     */
    searchBrowseI18n: {
      type: Object,
    },
    /**
     * indicates whether the site is configured for single product view
     */
    singleProductEnabled: {
      type: Boolean,
      default: false,
    },
    /**
     * indicates whether the site is configured for bulk
     */
    isBulkEnabled: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [mobileMixin],
  components: {
    vxProductTileVertical,
  },
  created() {
    this.viewportSize = window.innerWidth;
    this.getViewportSize(this.viewportSize);
  },
  methods: {
    getViewportSize(e) {
      if (e < 768) {
        this.viewportCount = 2;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/b2c/search-browse/vx-list-page/vx-list-page.js